import React from 'react';
import {CheckinQRCode} from '../../../welcomeCommon/CheckinQRCode';
import {useTenantContext} from '../../../../common/context/TenantContext';

export const SingleTenantCheckinQRCode = () => {
  const {translationsProvider, tenantData} = useTenantContext();
  return <CheckinQRCode tenantData={tenantData} isMultiTenant={false} translations={translationsProvider} />;
};
